/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { expVal } from '@atlassian/jira-feature-experiments';
import { FE_UNATTRIBUTED } from '../../constants.tsx';

let activeCapability: string | null = null;

export const setCapability = (capability: string | null): void => {
	activeCapability = capability;
};

export const getCapability = (): string | null =>
	activeCapability ??
	(expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false) ? FE_UNATTRIBUTED : null);
